module.exports = __webpack_public_path__ + "img/clean_king.da7a7c4a.png";